import { createStyles } from '@mantine/core';

export default createStyles((theme, _params, getRef) => {
  return {
    navbar: {
      color: theme.white,
      backgroundColor: theme.other.colors.appBlue,
    },
    navSection: {
      marginLeft: -theme.spacing.md,
      marginRight: -theme.spacing.md,
    },
    logo: {
      width: '100%',
    },
    logoWrapper: {
      width: 170,
      margin: '0 auto',
      marginBottom: 26,
    },
    linksInner: {
      paddingTop: theme.spacing.xl,
      paddingBottom: theme.spacing.xl,
    },
  };
});
